// T027: Implement array-to-object transformation utility

import { Post } from '@/types/post'
import { FeedsAPIRow } from '@/types/feed'
import { getPostUrl } from '@/utils/permlink'
import { generateSummary, calculateReadTime } from '@/utils/titleGenerator'

/**
 * Transforms SteemWorld API array response to Post object
 * Field mapping based on SteemWorld Feeds API documentation
 */
export function transformFeedRow(row: FeedsAPIRow): Post {
  // Type assertion for array indexing
  const data = row as unknown[]

  // Parse JSON metadata safely
  let tags: string[] = []
  let images: string[] = []

  try {
    const metadata = JSON.parse((data[30] as string) || '{}')
    tags = metadata.tags || []
    images = metadata.image || []
  } catch {
    tags = []
    images = []
  }

  const author = (data[6] as string) || ''
  const permlink = (data[7] as string) || ''
  const category = (data[27] as string) || ''
  const title = (data[31] as string) || ''
  const body = (data[32] as string) || ''

  return {
    linkId: (data[0] as number) || 0,
    author,
    permlink,
    created: new Date((data[8] as number) * 1000),
    lastUpdate: new Date((data[9] as number) * 1000),
    cashoutTime: new Date((data[10] as number) * 1000),
    title,
    body,
    tags,
    category,
    images,
    upvoteCount: (data[19] as number) || 0,
    downvoteCount: (data[20] as number) || 0,
    commentCount: (data[17] as number) || 0,
    resteemCount: 0, // Not directly available in API
    payout: (data[11] as number) || 0,
    payoutComments: (data[12] as number) || 0,
    promoted: (data[13] as number) || 0,
    maxAcceptedPayout: 0, // Would need to parse from data
    percentSteemDollars: 10000, // Default 100%
    authorReputation: (data[23] as number) || 0,
    authorTitle: (data[24] as string) || null,
    parentAuthor: '',
    parentPermlink: category,
    community: (data[28] as string) || null,
    isPinned: (data[15] as number) === 1,
    isMuted: (data[16] as number) === 1,
    resteemedBy: null,
    url: getPostUrl(category, author, permlink),
    summary: generateSummary(body),
    readTime: calculateReadTime(body),
  }
}

/**
 * Transforms array of feed rows to array of Posts
 */
export function transformFeedResponse(rows: FeedsAPIRow[]): Post[] {
  if (!rows || !Array.isArray(rows)) {
    console.error('Invalid rows data:', rows)
    return []
  }
  return rows.map(transformFeedRow)
}
